/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export const sysqueFamilyPartTypeList = [
  'Elbow',
  'JunctionBoxElbow',
  'Tee',
  'JunctionBoxTee',
  'Cross',
  'JunctionBoxCross',
  'Union',
  'Transition',
  'Cap',
  'MultiPort',

  'ChannelCableTrayElbow',
  'ChannelCableTrayTee',
  'ChannelCableTrayCross',
  'ChannelCableTrayUnion',
  'ChannelCableTrayTransition',
  'ChannelCableTrayOffset',
  'ChannelCableTrayMultiPort',

  'LadderCableTrayElbow',
  'LadderCableTrayTee',
  'LadderCableTrayCross',
  'LadderCableTrayUnion',
  'LadderCableTrayTransition',
  'LadderCableTrayOffset',
  'LadderCableTrayMultiPort'
];
